import React, { useContext, useEffect, useState } from 'react';
import { SocketContext } from '../../context/SocketContext';
import { useParams } from 'react-router-dom';
import { ProgressBar, Alert } from 'react-bootstrap';

const TabMikrotik = (active = true) => {
    const { id } = useParams();
    const idR = atob(id);
    const { socket } = useContext(SocketContext);
    const [start, setStart] = useState(0);
    const [data, setData] = useState(null);
    useEffect(() => {
        if (!active) {
            setStart(0);
            setData(null);
        } else {
            setStart(1);
        }
    }, [active]);
    useEffect(() => {
        if (start === 0) {
            getData();
        }
    }, [start]);
    const getData = async () => {
        if (active) {
            setStart(start + 1);
            await socket.emit('infomk', idR, (status) => {
                if (status) {
                    if (status.ok) {
                        setData(status.data);
                    } else {
                        setData(false);
                    }
                }
            });
        }
    };
    if (data === null)
        return (
            <div className="m-2">
                <ProgressBar now={65} variant="primary" animated />
            </div>
        );
    if (data === false)
        return (
            <div className="m-2 text-center">
                <Alert variant="danger">ERROR AL CONECTAR CON EL EQUIPO!!</Alert>{' '}
            </div>
        );
    return (
        <div className="p-4 text-center">
            <h4>INFORMACIÓN DEL ROUTER</h4>
            <ul className="list-unstyled mb-0">
                <li>Uptime: {data.uptime}</li>
                <li>Version:{data.version}</li>
                <li>build-time:{data['build-time']}</li>
                <li>factory-software:{data['factory-software']}</li>
                <li>free-memory:{data['free-memory']}</li>
                <li>total-memory:{data['total-memory']}</li>
                <li>cpu:{data['cpu']}</li>
                <li>cpu-count:{data['cpu-count']}</li>
                <li>cpu-frequency:{data['cpu-frequency']}</li>
                <li className=" justify-center flex items-center  text-center py-1 bg-gray-300 dark:bg-gray-500">
                    cpu-load :
                    <div className="w-1/2 bg-gray-200 rounded-full dark:bg-gray-700">
                        <ProgressBar now={data['cpu-load']} label={`${data['cpu-load']}%`} />
                    </div>
                </li>
                <li>free-hdd-space :{data['free-hdd-space']}</li>
                <li>total-hdd-space:{data['total-hdd-space']}</li>
                <li>architecture-name:{data['architecture-name']}</li>
                <li>board-name:{data['board-name']}</li>
                <li>platform:{data.platform}</li>
            </ul>
        </div>
    );
};

export default TabMikrotik;
